import {
  ASSESSMENT_CATEGORY_LIST, 
  ASSESSMENT_CATEGORY_LIST_SUCCESS, 
  ASSESSMENT_CATEGORY_LIST_ERROR,
  ASSESSMENT_CATEGORY_SEARCH_SET, 
  ASSESSMENT_CATEGORY_SEARCH_CHANGE, 
  ASSESSMENT_CATEGORY_PAGE_SET, 
  ASSESSMENT_CATEGORY_ADD_SET,
  ASSESSMENT_CATEGORY_ADD_MODAL_SET,
  ASSESSMENT_CATEGORY_ADD,
  ASSESSMENT_CATEGORY_ADD_SUCCESS,
  ASSESSMENT_CATEGORY_ADD_ERROR,
  ASSESSMENT_CATEGORY_ADD_CHANGE,
  ASSESSMENT_CATEGORY_DETAIL,
  ASSESSMENT_CATEGORY_DETAIL_SUCCESS,
  ASSESSMENT_CATEGORY_DETAIL_ERROR,
  ASSESSMENT_CATEGORY_VIEW_MODAL_SET,
  ASSESSMENT_CATEGORY_EDIT_CHANGE,
  ASSESSMENT_CATEGORY_EDIT_MODAL_SET,
  ASSESSMENT_CATEGORY_UPDATE,
  ASSESSMENT_CATEGORY_UPDATE_SUCCESS,
  ASSESSMENT_CATEGORY_UPDATE_ERROR,
  ASSESSMENT_CATEGORY_VIEW_TAB_SET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 1000
    }
  },
  add: {
    data: {
      new:{
        name: ''
      }
    },
    modal: false,
    loading: false,
    message: '',
    url: '',
    type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{},
    value:{}
  },
  detail: {
    data: [],
    tab: '1',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: '1',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
    },
    search: {
        modal: false,
        init: true
    }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ASSESSMENT_CATEGORY_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case ASSESSMENT_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case ASSESSMENT_CATEGORY_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case ASSESSMENT_CATEGORY_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case ASSESSMENT_CATEGORY_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case ASSESSMENT_CATEGORY_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case ASSESSMENT_CATEGORY_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case ASSESSMENT_CATEGORY_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case ASSESSMENT_CATEGORY_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { 
              name: ''
            }
          },
          modal: action.payload
        }
      }
    case ASSESSMENT_CATEGORY_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case ASSESSMENT_CATEGORY_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case ASSESSMENT_CATEGORY_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case ASSESSMENT_CATEGORY_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case ASSESSMENT_CATEGORY_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case ASSESSMENT_CATEGORY_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case ASSESSMENT_CATEGORY_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case ASSESSMENT_CATEGORY_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case ASSESSMENT_CATEGORY_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case ASSESSMENT_CATEGORY_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case ASSESSMENT_CATEGORY_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case ASSESSMENT_CATEGORY_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case ASSESSMENT_CATEGORY_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
          }

    default:
      return { ...state };
    }

};